import { useEffect } from 'react';
import { observer } from 'mobx-react';

import { CellFilterValueList } from '../../CellFilter/Views/CellFilterValueList';
import { useFilterValueList } from '../Hooks/useFilterValueList';

/**
 * @property columnKey - string; Column key to match data key
 * @property includedValues - string[]; Array of values to include to data (SELECT_ALL is not checked)
 * @property searchIsActive - boolean; If filter's value search is active do not hide all rows and apply filters accordingly (include/exclude)
 * @property selectAllChecked - boolean; SELECT_ALL checked state
 * @property setIncludedValues - (string) => void; Callback to change includedValues state
 * @property setSelectAllChecked - (boolean) => void; Callback to change SELECT_ALL state
 */
type Props = {
  columnKey: string;
  includedValues: Set<string>
  searchIsActive?: boolean
  selectAllChecked: boolean
  setIncludedValues: (value: Set<string>) => void
  setSelectAllChecked: (value: boolean) => void
  onClose: () => void
};

/**
 * @component FilterValueList - This component is a part of CellFilter. Component used in UserManagement Grid.
 * Main goal of isolating FilterValueList is to fetch Cell Filter Values separately on list render instead of Grid render.
 */
export const FilterValueList = observer(({ onClose, ...rest }: Props) => {
  const {
    isFetching,
    filterItems,
    handleScroll,
    handleCheckboxChange
  } = useFilterValueList(rest);

  useEffect(() => {
    // call onClose on unmount
    return () => onClose()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <CellFilterValueList
      data={filterItems}
      isLoading={isFetching}
      handleScroll={handleScroll}
      onCheckedChange={(checked, item) => (
        handleCheckboxChange({
          ...item,
          isChecked: !checked as boolean
        })
      )}
    />
  );
})
